// extracted by mini-css-extract-plugin
var _1 = "NotificationLink-modulelink__bYt_R";
export { _1 as "link" }
